module.exports = __webpack_public_path__ + "media/images/map-8be8fb0db5393889f1075bf36757a013.gif";